// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
@font-face {
  font-family: "Barlow";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('barlow-v13-latin-regular.woff2') format("woff2");
}
@font-face {
  font-display: swap;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  src: url('montserrat-v31-latin-regular.woff2') format("woff2");
}
@font-face {
  font-family: "Barlow";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url('barlow-v13-latin-500.woff2') format("woff2");
}
@font-face {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url('montserrat-v31-latin-500.woff2') format("woff2");
}
@font-face {
  font-family: "Barlow";
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url('barlow-v13-latin-600.woff2') format("woff2");
}
@font-face {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url('montserrat-v31-latin-600.woff2') format("woff2");
}
@font-face {
  font-family: "Barlow";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url('barlow-v13-latin-700.woff2') format("woff2");
}
@font-face {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url('montserrat-v31-latin-700.woff2') format("woff2");
}
@font-face {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: 400;
  src: url('material-icons-v145-latin-regular.woff2') format("woff2");
  font-display: block;
}
.material-icons {
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}

body {
  font-family: "Barlow", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
}

h1 {
  font-size: 64px;
  line-height: 78px;
}

h2 {
  font-size: 56px;
  line-height: 68px;
}

h3 {
  font-size: 48px;
  line-height: 58px;
}

h4 {
  font-size: 40px;
  line-height: 48px;
}

h5 {
  font-size: 32px;
  line-height: 39px;
}

h6 {
  font-size: 24px;
  line-height: 29px;
}

a {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: rgb(174, 15, 10);
  cursor: pointer;
  text-decoration: underline;
}

caption {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}

th {
  font-weight: 700;
  cursor: pointer;
  text-wrap: nowrap;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pr-0 {
  padding-right: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.m-0 {
  margin: 0px;
}

.mt-0 {
  margin-top: 0px;
}

.mr-0 {
  margin-right: 0px;
}

.mb-0 {
  margin-bottom: 0px;
}

.ml-0 {
  margin-left: 0px;
}

.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.p-1 {
  padding: 8px;
}

.pt-1 {
  padding-top: 8px;
}

.pr-1 {
  padding-right: 8px;
}

.pb-1 {
  padding-bottom: 8px;
}

.pl-1 {
  padding-left: 8px;
}

.px-1 {
  padding-left: 8px;
  padding-right: 8px;
}

.py-1 {
  padding-top: 8px;
  padding-bottom: 8px;
}

.m-1 {
  margin: 8px;
}

.mt-1 {
  margin-top: 8px;
}

.mr-1 {
  margin-right: 8px;
}

.mb-1 {
  margin-bottom: 8px;
}

.ml-1 {
  margin-left: 8px;
}

.mx-1 {
  margin-left: 8px;
  margin-right: 8px;
}

.my-1 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.p-2 {
  padding: 16px;
}

.pt-2 {
  padding-top: 16px;
}

.pr-2 {
  padding-right: 16px;
}

.pb-2 {
  padding-bottom: 16px;
}

.pl-2 {
  padding-left: 16px;
}

.px-2 {
  padding-left: 16px;
  padding-right: 16px;
}

.py-2 {
  padding-top: 16px;
  padding-bottom: 16px;
}

.m-2 {
  margin: 16px;
}

.mt-2 {
  margin-top: 16px;
}

.mr-2 {
  margin-right: 16px;
}

.mb-2 {
  margin-bottom: 16px;
}

.ml-2 {
  margin-left: 16px;
}

.mx-2 {
  margin-left: 16px;
  margin-right: 16px;
}

.my-2 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.p-3 {
  padding: 24px;
}

.pt-3 {
  padding-top: 24px;
}

.pr-3 {
  padding-right: 24px;
}

.pb-3 {
  padding-bottom: 24px;
}

.pl-3 {
  padding-left: 24px;
}

.px-3 {
  padding-left: 24px;
  padding-right: 24px;
}

.py-3 {
  padding-top: 24px;
  padding-bottom: 24px;
}

.m-3 {
  margin: 24px;
}

.mt-3 {
  margin-top: 24px;
}

.mr-3 {
  margin-right: 24px;
}

.mb-3 {
  margin-bottom: 24px;
}

.ml-3 {
  margin-left: 24px;
}

.mx-3 {
  margin-left: 24px;
  margin-right: 24px;
}

.my-3 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.p-4 {
  padding: 32px;
}

.pt-4 {
  padding-top: 32px;
}

.pr-4 {
  padding-right: 32px;
}

.pb-4 {
  padding-bottom: 32px;
}

.pl-4 {
  padding-left: 32px;
}

.px-4 {
  padding-left: 32px;
  padding-right: 32px;
}

.py-4 {
  padding-top: 32px;
  padding-bottom: 32px;
}

.m-4 {
  margin: 32px;
}

.mt-4 {
  margin-top: 32px;
}

.mr-4 {
  margin-right: 32px;
}

.mb-4 {
  margin-bottom: 32px;
}

.ml-4 {
  margin-left: 32px;
}

.mx-4 {
  margin-left: 32px;
  margin-right: 32px;
}

.my-4 {
  margin-top: 32px;
  margin-bottom: 32px;
}

.p-5 {
  padding: 40px;
}

.pt-5 {
  padding-top: 40px;
}

.pr-5 {
  padding-right: 40px;
}

.pb-5 {
  padding-bottom: 40px;
}

.pl-5 {
  padding-left: 40px;
}

.px-5 {
  padding-left: 40px;
  padding-right: 40px;
}

.py-5 {
  padding-top: 40px;
  padding-bottom: 40px;
}

.m-5 {
  margin: 40px;
}

.mt-5 {
  margin-top: 40px;
}

.mr-5 {
  margin-right: 40px;
}

.mb-5 {
  margin-bottom: 40px;
}

.ml-5 {
  margin-left: 40px;
}

.mx-5 {
  margin-left: 40px;
  margin-right: 40px;
}

.my-5 {
  margin-top: 40px;
  margin-bottom: 40px;
}

.p-6 {
  padding: 48px;
}

.pt-6 {
  padding-top: 48px;
}

.pr-6 {
  padding-right: 48px;
}

.pb-6 {
  padding-bottom: 48px;
}

.pl-6 {
  padding-left: 48px;
}

.px-6 {
  padding-left: 48px;
  padding-right: 48px;
}

.py-6 {
  padding-top: 48px;
  padding-bottom: 48px;
}

.m-6 {
  margin: 48px;
}

.mt-6 {
  margin-top: 48px;
}

.mr-6 {
  margin-right: 48px;
}

.mb-6 {
  margin-bottom: 48px;
}

.ml-6 {
  margin-left: 48px;
}

.mx-6 {
  margin-left: 48px;
  margin-right: 48px;
}

.my-6 {
  margin-top: 48px;
  margin-bottom: 48px;
}

.p-7 {
  padding: 56px;
}

.pt-7 {
  padding-top: 56px;
}

.pr-7 {
  padding-right: 56px;
}

.pb-7 {
  padding-bottom: 56px;
}

.pl-7 {
  padding-left: 56px;
}

.px-7 {
  padding-left: 56px;
  padding-right: 56px;
}

.py-7 {
  padding-top: 56px;
  padding-bottom: 56px;
}

.m-7 {
  margin: 56px;
}

.mt-7 {
  margin-top: 56px;
}

.mr-7 {
  margin-right: 56px;
}

.mb-7 {
  margin-bottom: 56px;
}

.ml-7 {
  margin-left: 56px;
}

.mx-7 {
  margin-left: 56px;
  margin-right: 56px;
}

.my-7 {
  margin-top: 56px;
  margin-bottom: 56px;
}

.p-8 {
  padding: 64px;
}

.pt-8 {
  padding-top: 64px;
}

.pr-8 {
  padding-right: 64px;
}

.pb-8 {
  padding-bottom: 64px;
}

.pl-8 {
  padding-left: 64px;
}

.px-8 {
  padding-left: 64px;
  padding-right: 64px;
}

.py-8 {
  padding-top: 64px;
  padding-bottom: 64px;
}

.m-8 {
  margin: 64px;
}

.mt-8 {
  margin-top: 64px;
}

.mr-8 {
  margin-right: 64px;
}

.mb-8 {
  margin-bottom: 64px;
}

.ml-8 {
  margin-left: 64px;
}

.mx-8 {
  margin-left: 64px;
  margin-right: 64px;
}

.my-8 {
  margin-top: 64px;
  margin-bottom: 64px;
}

.p-9 {
  padding: 72px;
}

.pt-9 {
  padding-top: 72px;
}

.pr-9 {
  padding-right: 72px;
}

.pb-9 {
  padding-bottom: 72px;
}

.pl-9 {
  padding-left: 72px;
}

.px-9 {
  padding-left: 72px;
  padding-right: 72px;
}

.py-9 {
  padding-top: 72px;
  padding-bottom: 72px;
}

.m-9 {
  margin: 72px;
}

.mt-9 {
  margin-top: 72px;
}

.mr-9 {
  margin-right: 72px;
}

.mb-9 {
  margin-bottom: 72px;
}

.ml-9 {
  margin-left: 72px;
}

.mx-9 {
  margin-left: 72px;
  margin-right: 72px;
}

.my-9 {
  margin-top: 72px;
  margin-bottom: 72px;
}

.p-10 {
  padding: 80px;
}

.pt-10 {
  padding-top: 80px;
}

.pr-10 {
  padding-right: 80px;
}

.pb-10 {
  padding-bottom: 80px;
}

.pl-10 {
  padding-left: 80px;
}

.px-10 {
  padding-left: 80px;
  padding-right: 80px;
}

.py-10 {
  padding-top: 80px;
  padding-bottom: 80px;
}

.m-10 {
  margin: 80px;
}

.mt-10 {
  margin-top: 80px;
}

.mr-10 {
  margin-right: 80px;
}

.mb-10 {
  margin-bottom: 80px;
}

.ml-10 {
  margin-left: 80px;
}

.mx-10 {
  margin-left: 80px;
  margin-right: 80px;
}

.my-10 {
  margin-top: 80px;
  margin-bottom: 80px;
}

html {
  --mdc-outlined-text-field-focus-outline-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mdc-outlined-text-field-focus-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-option-selected-state-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-datepicker-toggle-active-state-icon-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mat-paginator-enabled-icon-color: rgba(34, 36, 40, 1) !important;
}

::ng-deep .mdc-notched-outline__leading {
  border-color: rgb(239, 239, 239) !important;
}

::ng-deep .mdc-notched-outline__notch {
  border-color: rgb(239, 239, 239) !important;
}

::ng-deep .mdc-notched-outline__trailing {
  border-color: rgb(239, 239, 239) !important;
}

.mat-drawer-content {
  background-color: white !important;
}

.no-subscript .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.modal-lg {
  --width: 670px;
}

.modal-foto-crop {
  --width: 520px;
  --height: 640px;
  --border-radius: 8px;
}

.modal-lg-user {
  --width: 600px;
  --height: 495px;
}

.modal-lg-equipamentos {
  --width: 470px;
  --height: 550px;
}

.modal-lg-consorcio {
  --width: 600px;
  --height: 515px;
}

.modal-lg-add-consorcio {
  --width: 790px;
  --height: 590px;
}

.modal-lg-endereço {
  --width: 600px;
  --height: 475px;
}

.modal-lg-comunicacao-qco {
  --width: 470px;
  --height: 280px;
}

.modal-lg-gerar-qco {
  --width: 440px;
  --height: 235px;
}

.modal-motivo-recusa {
  --width: 470px;
  --height: 280px;
}

.popover-content {
  width: 23rem;
}

ion-popover.notifications-popover {
  --offset-y: 20px;
}
ion-popover.notifications-popover::part(content) {
  padding: 15px;
  overflow: auto;
  max-height: 80vh;
}

ion-popover::part(content) {
  padding: 20px;
  height: auto;
  overflow: visible;
}

ion-popover.workflow-status::part(content) {
  padding: 8px;
  height: auto;
  overflow: visible;
}

ion-popover {
  --height: var(--popover-height);
}
ion-popover.workflow-status {
  --backdrop-opacity: 0;
  --width: auto;
}
ion-popover.datetime-popover {
  --backdrop-opacity: 0;
}

ion-accordion ion-icon.ion-accordion-toggle-icon {
  display: none;
}

/* You can add global styles to this file, and also import other style files */
/* Angular 15 adds grey background on mat form components */
/* below removes that background color */
/* Manipulate initial background color*/
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

/*Manipulate background color on hover and focus*/
.mat-mdc-form-field-focus-overlay {
  background-color: transparent !important;
}

.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {
  width: 0px;
  padding-left: 6px;
  padding-right: 6px;
}
.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted span {
  display: none;
}

.mat-mdc-table {
  --mat-table-header-headline-line-height: 56px;
  border-collapse: separate !important;
  border-spacing: 0 4px !important;
}
.mat-mdc-table thead {
  border-spacing: 0 !important;
}

.mat-mdc-row {
  margin-bottom: 10px;
}

.mat-mdc-cell {
  padding-top: 6px;
  padding-bottom: 6px;
}

/* Pagination menu */
.g-bubble-container {
  display: flex;
}

.g-bubble {
  border: 1px solid rgb(239, 239, 239);
  margin: 0 10px;
  border-radius: 4px;
  min-width: 34px;
  max-width: 40px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(34, 36, 40) !important;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: center;
  margin-right: 0 !important;
}
@media (max-width: 425px) {
  .g-bubble {
    width: 30px;
  }
}

.g-bubble:hover {
  background-color: rgb(189, 188, 188);
  color: rgb(245, 246, 249);
}

.g-bubble__active {
  background-color: rgb(227, 6, 19);
  color: rgb(227, 227, 227) !important;
}

mat-paginator {
  background: transparent !important;
  margin-top: 48px !important;
}

.mat-mdc-paginator-container {
  justify-content: flex-start;
  flex-wrap: wrap;
}

.mat-mdc-paginator-range-actions {
  align-items: flex-start !important;
  overflow-wrap: anywhere !important;
  flex-grow: 1;
  justify-content: center !important;
  position: relative !important;
}

.bubble-paginator-dots {
  font-size: 16px !important;
  margin-right: 2px !important;
  margin-left: 2px !important;
}
@media (max-width: 425px) {
  .bubble-paginator-dots {
    font-size: 12px !important;
    margin-right: -5px !important;
  }
}

.mat-mdc-paginator-page-size {
  margin-right: 0 !important;
}
@media (max-width: 320px) {
  .mat-mdc-paginator-page-size {
    width: 33% !important;
  }
}

@media (max-width: 496px) {
  .mat-mdc-paginator-page-size-label {
    display: none !important;
  }
}

.mat-mdc-paginator-range-label {
  align-self: center;
}
@media (max-width: 768px) {
  .mat-mdc-paginator-range-label {
    margin-left: 0px !important;
  }
}

.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {
  position: absolute !important;
  left: 0 !important;
}

.mat-mdc-paginator-container:not(:has(.mat-mdc-paginator-page-size)) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {
  position: absolute;
  left: 24px;
}

.mat-mdc-paginator-navigation-next,
.mat-mdc-paginator-navigation-previous {
  border: 1px solid rgb(239, 239, 239) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: rgb(34, 36, 40) !important;
  padding: 0 !important;
  border-radius: 4px !important;
  width: 28px !important;
  height: 34px !important;
  margin-left: 8px !important;
}

.mat-mdc-paginator-page-size-select {
  max-width: 60px !important;
  margin-right: 8px !important;
}
.mat-mdc-paginator-page-size-select .mat-mdc-text-field-wrapper {
  padding: 0 8px 0 16px !important;
}

/* End of pagination menu */
body {
  margin: 0;
}

.snackbar {
  width: 50vw;
  margin: 10px 0px !important;
}
.snackbar .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
}
.snackbar .mdc-snackbar__label {
  color: black !important;
}
.snackbar .mat-icon {
  margin-right: 12px;
}

.snackbar-custom {
  width: 50vw;
  margin-top: 75px !important;
}

.snacbar-warning {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-warning .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid #e0ac08;
}
.snacbar-warning .mdc-snackbar__label {
  color: black !important;
}
.snacbar-warning .mat-icon {
  margin-right: 12px;
}

.snacbar-sucess {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-sucess .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid green;
}
.snacbar-sucess .mdc-snackbar__label {
  color: black !important;
}
.snacbar-sucess .mat-icon {
  margin-right: 12px;
}

.snacbar-error {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-error .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid red;
}
.snacbar-error .mdc-snackbar__label {
  color: black !important;
}
.snacbar-error .mat-icon {
  margin-right: 12px;
}

.flex {
  display: flex;
}

.mat-mdc-menu-panel {
  overflow: hidden !important;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .menu-header {
  font-size: 12px;
  padding: 1rem;
  padding-bottom: 0.25rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item {
  margin-left: 1rem;
  padding-left: 0;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:first-of-type {
  margin-top: 0.75rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:not(:last-child) {
  border-bottom: 1px solid rgb(189, 188, 188);
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 30000;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sort-icon-container {
  display: inline-flex;
  align-items: center;
}
.sort-icon-container mat-icon {
  height: 1rem;
  width: 1rem;
}

.drag-icon-container {
  display: inline-flex;
  align-items: center;
  margin-right: 12px;
}
.drag-icon-container mat-icon {
  height: 1rem;
  width: 14px;
}

.btn-primary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(174, 15, 10);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0.25rem;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 100%;
    height: 45px;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(239, 239, 239);
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed.btn-small {
  width: 7rem;
}

.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
  background: white;
  color: rgb(174, 15, 10);
  border: 1px solid rgb(174, 15, 10);
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0.25rem;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.btn-secondary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  color: rgb(228, 173, 181);
  border-color: rgb(228, 173, 181);
}
.btn-secondary.mat-mdc-unelevated-button.mat-unthemed.btn-small {
  width: 7rem;
}
.btn-secondary.mat-mdc-unelevated-button.mat-unthemed.no-border {
  border: none;
}

.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(189, 188, 188);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0.25rem;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed.btn-small {
  width: 7rem;
}

.status-container {
  display: flex;
  align-items: center;
}
.status-container .mat-icon {
  width: 1rem;
}
.status-container .status-icon {
  font-size: 8px;
  align-content: center;
  text-align: center;
  margin-right: 8px;
}
.status-container .status-icon.verde {
  color: rgb(41, 204, 106);
}
.status-container .status-icon.amarelo {
  color: rgb(255, 196, 9);
}
.status-container .status-icon.azul {
  color: rgb(0, 153, 255);
}
.status-container .status-icon.lilas {
  color: rgb(82, 96, 255);
}
.status-container .status-icon.roxo {
  color: rgb(82, 96, 255);
}
.status-container .status-icon.vermelho {
  color: rgb(227, 6, 19);
}
.status-container .active {
  color: rgb(40, 186, 98);
}
.status-container .inactive {
  color: rgb(235, 68, 90);
}

.text-capitalize {
  text-transform: capitalize;
}

::ng-deep .mat-calendar-body-selected {
  background-color: rgb(174, 15, 10) !important;
}

::ng-deep .mat-calendar-body-cell-content {
  border-radius: 0rem !important;
}

::ng-deep .mat-calendar-body-selected.mat-calendar-body-today {
  box-shadow: none;
}

.mat-checkbox.custom-checkbox {
  --background-checked: rgba(174, 15, 10, 1) !important;
  --mdc-checkbox-selected-icon-color: rgba(174, 15, 10, 1) !important;
  --mdc-checkbox-selected-hover-icon-color: rgba(174, 15, 10, 1) !important;
  --mdc-checkbox-selected-pressed-icon-color: rgba(174, 15, 10, 1) !important;
  --mdc-checkbox-selected-focus-icon-color: rgba(174, 15, 10, 1) !important;
  --mdc-checkbox-selected-focus-state-layer-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mdc-checkbox-selected-hover-state-layer-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mdc-checkbox-selected-pressed-state-layer-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
}

/* 
  IONIC components
*/
.margin-left {
  margin-left: 1rem;
}

.margin-right {
  margin-right: 1rem;
}

.margin-top {
  margin-top: 1rem;
}

.margin-top-md {
  margin-top: 0.5rem;
}

.margin-top-xl {
  margin-top: 2rem;
}

.margin-bottom {
  margin-top: 1rem;
}

.no-padding {
  padding: 0;
}

ion-input,
mat-form-field {
  width: 100%;
  display: block;
}

ion-checkbox {
  --border-color: rgba(218, 218, 218, 1) !important;
  --checkbox-background-checked: rgba(174, 15, 10, 1) !important;
  --border-color-checked: rgba(174, 15, 10, 1) !important;
}

ion-textarea,
ion-input {
  --background: white !important;
  --border-color: rgba(239, 239, 239, 1) !important;
  --border-radius: 5px !important;
  --highlight-color: rgba(135, 135, 135, 1);
  --highlight-color-focused: rgba(135, 135, 135, 1) !important;
  --highlight-color-valid: rgba(135, 135, 135, 1) !important;
  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;
}

ion-input label .label-text {
  color: rgb(87, 87, 86) !important;
}

ion-input.valid-input label .label-text {
  color: rgb(45, 211, 111) !important;
}

ion-input.invalid-input label .label-text {
  color: rgb(227, 6, 19) !important;
}

ion-textarea label .label-text {
  color: rgb(87, 87, 86) !important;
}

@media (min-width: 1000px) {
  .filter-panel {
    width: 650px !important;
    height: 450px !important;
  }
  .historic-panel {
    min-width: 49.5rem;
    min-height: 35.625rem;
  }
}
@media (max-width: 900px) {
  .filter-panel {
    min-height: 30rem;
  }
}
@media (max-width: 767px) {
  .filter-panel {
    width: 480px !important;
    height: 650px !important;
  }
}
@media (max-width: 600px) {
  .mat-mdc-form-field-label {
    font-size: 0.8rem;
    /* Tamanho de fonte para dispositivos móveis */
  }
}
ion-modal.modal-xsm {
  --max-height: 45%;
}

ion-modal.modal-sm {
  --max-height: 65%;
}

ion-modal.modal-h-auto {
  --height: auto;
}
ion-modal.modal-h-auto .header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
ion-modal.modal-h-auto .header ion-item {
  font-size: 1.2rem;
  font-weight: bold;
  margin-right: 1.2rem;
  font-family: "Montserrat", sans-serif;
}

ion-modal.modal-w-auto {
  --width: auto;
  overflow: auto;
}
ion-modal.modal-w-auto .header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}
ion-modal.modal-w-auto .header ion-item {
  font-weight: 700;
  font-size: 16px;
}
ion-modal.modal-w-auto .header ion-icon {
  font-size: 16px;
  margin-right: 8px;
}

ion-modal.modal-hw-auto {
  overflow: auto;
}
@media (min-width: 768px) {
  ion-modal.modal-hw-auto {
    --width: auto;
    --height: auto;
  }
}
ion-modal.modal-hw-auto .ion-delegate-host.ion-page {
  max-height: 100%;
  overflow: auto;
}
ion-modal.modal-hw-auto .header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}
ion-modal.modal-hw-auto .header ion-item {
  font-weight: 700;
  font-size: 16px;
}
ion-modal.modal-hw-auto .header ion-icon {
  font-size: 16px;
  margin-right: 8px;
}

ion-alert.custom-alert {
  --backdrop-opacity: 0.7;
}

ion-list.filtered-list {
  display: flex;
  flex-wrap: wrap;
}
ion-list.filtered-list span {
  padding: 0.75rem 0;
  margin: 0 0.75rem;
  border-bottom: 1px solid rgb(189, 188, 188);
  width: 100%;
}

ion-item.no-padding-start {
  --padding-start: 0;
}

ion-item.no-padding-end {
  --padding-end: 0;
}

ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-item.no-padding-full {
  --padding-end: 0;
  --padding-start: 0;
  --inner-padding-end: 0;
  --inner-padding-start: 0;
}

ion-input.no-padding-end {
  --padding-end: 0;
}

ion-item {
  overflow: visible;
}

/* 
  Mais filtros
*/
ion-button.more-filters-btn {
  --background: rgba(174, 15, 10, 1);
  --color: white;
  --border-radius: 10px;
  width: 114px;
  height: 36px;
  max-width: 15rem;
  text-transform: capitalize;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.08em;
}

ion-item.fast-filters {
  padding: 0.25rem 0rem;
}

.more-filters-btn-row {
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.more-filters-btn-row button {
  margin: 5px;
}
@media (max-width: 767px) {
  .more-filters-btn-row button {
    margin: 5px 0;
  }
}

ion-col {
  padding: 0 !important;
}

/* 
  IONIC alert
*/
.custom-alert .alert-wrapper .alert-head {
  padding-top: 0;
}
.custom-alert .alert-wrapper .alert-title {
  font-weight: 700;
  font-size: 1rem !important;
  color: rgb(34, 36, 40) !important;
}
.custom-alert .alert-wrapper .alert-message {
  font-weight: 400;
  font-size: 1rem !important;
  line-height: 24px;
  color: rgb(112, 111, 111) !important;
}
.custom-alert .alert-wrapper .alert-button-group {
  justify-content: flex-end;
}
.custom-alert .alert-wrapper button.alert-button.alert-button-confirm {
  font-weight: 600;
  color: rgb(174, 15, 10);
}
.custom-alert .alert-wrapper button.alert-button.alert-button-cancel {
  font-weight: 600;
  color: rgb(112, 111, 111);
}

ion-toast.snackbar-toast {
  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
  --width: fit-content;
  --border-radius: 0.75rem;
  --white-space: pre-line;
}
@media (min-width: 768px) {
  ion-toast.snackbar-toast {
    transform: translateY(calc(20px + var(--ion-safe-area-top, 0px))) translateX(calc(-12px + var(--ion-safe-area-top, 0px))) !important;
  }
}

ion-toast.snackbar-toast::part(container) {
  background: #fff;
  color: rgb(34, 36, 40);
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 0.75rem;
}

ion-toast.snackbar-toast.toast-success::part(container) {
  border: 1px solid rgb(45, 211, 111);
}
ion-toast.snackbar-toast.toast-success::part(icon) {
  color: rgb(45, 211, 111);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-error::part(container) {
  border: 1px solid rgb(235, 68, 90);
}
ion-toast.snackbar-toast.toast-error::part(icon) {
  color: rgb(235, 68, 90);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-warning::part(container) {
  border: 1px solid rgb(255, 165, 10);
}
ion-toast.snackbar-toast.toast-warning::part(icon) {
  color: rgb(255, 165, 10);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast {
  --box-shadow: none;
  --background: none;
}
ion-toast.snackbar-toast.toast-right {
  --start: right;
}
ion-toast.snackbar-toast::part(container) {
  transform: translateY(72px) !important;
  box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
}

ion-icon.search-icon-absolute {
  position: absolute;
  left: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 3;
}

ion-input.search-input label.input-wrapper {
  --padding-start: 55px;
}

ion-toggle {
  --handle-background-checked: rgba(174, 15, 10, 1);
  --track-background-checked: rgba(174, 15, 10, 0.38);
}

.cdk-overlay-container {
  z-index: 30000 !important;
}

.btn-transparent {
  background: none;
  border: none;
  padding: 0;
  display: inline-block;
}

.column-flex {
  display: flex;
  flex-flow: column;
}

.master-icon {
  background-color: rgb(255, 202, 34);
  color: rgb(34, 36, 40);
  border-radius: 10px;
  align-self: flex-start;
  font-size: 10px;
  padding: 0px 9px;
  margin: 6px 0;
  line-height: 17px;
  font-weight: 600;
}
.master-icon.center-horizontal {
  place-self: center;
}

.truncate-text-vertical {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}
.truncate-text-vertical.break-word {
  word-break: break-word;
}

.custom-tooltip {
  white-space: pre-line;
  transform: translateY(16px) !important;
}
.custom-tooltip .mdc-tooltip__surface {
  padding: 8px 24px;
  min-width: max-content;
  border: 1px solid #706f6f;
  --mdc-plain-tooltip-container-color: #383637 !important;
}
.custom-tooltip.strong .mdc-tooltip__surface {
  font-weight: 700 !important;
}

.cal-header {
  text-transform: capitalize !important;
}

.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: rgb(174, 15, 10) !important;
  font-weight: 600;
  font-size: 14px;
}

.mdc-tab__text-label {
  color: rgb(112, 111, 111) !important;
  font-weight: 600;
  font-size: 14px;
}

.mat-mdc-tab-group,
.mat-mdc-tab-nav-bar {
  --mdc-tab-indicator-active-indicator-color: rgba(174, 15, 10, 1) !important;
  --mat-tab-header-active-label-text-color: rgba(174, 15, 10, 1) !important;
  --mat-tab-header-active-ripple-color: rgba(174, 15, 10, 1) !important;
  --mat-tab-header-inactive-ripple-color: rgba(174, 15, 10, 1) !important;
  --mat-tab-header-active-focus-label-text-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mat-tab-header-active-hover-label-text-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mat-tab-header-active-focus-indicator-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mat-tab-header-active-hover-indicator-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
}

.mat-mdc-tab-header {
  background-color: rgb(244, 244, 244) !important;
}

.mdc-tab-indicator--active {
  background-color: white !important;
}

.mat-badge-content {
  background-color: rgb(174, 15, 10) !important;
}

.cdk-drag-preview {
  display: table;
  background: rgba(41, 204, 106, 0.08);
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
  width: 100%;
  table-layout: fixed;
}
.cdk-drag-preview td {
  padding: 16px;
  border-bottom: 1px solid #eee;
}

.cdk-drag-placeholder {
  opacity: 0.5;
  background: #f0f0f0;
}

.cdk-drag-animating {
  transition: transform 100ms cubic-bezier(0, 0, 0.2, 1);
}

.cdk-drop-list-dragging .mat-row:not(.cdk-drag-placeholder) {
  transition: transform 100ms cubic-bezier(0, 0, 0.2, 1);
}

.drag-enabled {
  cursor: move;
}

.drag-handle {
  display: none;
}

.drag-enabled .drag-handle {
  display: block;
  color: #999;
}

::ng-deep .cdk-drag-preview {
  display: table !important;
  table-layout: fixed;
  width: 100%;
  background: white;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(41, 204, 106, 0.08), 0 8px 10px 1px rgba(41, 204, 106, 0.08);
}
::ng-deep .cdk-drag-preview td {
  display: table-cell !important;
  vertical-align: middle;
  padding: 16px;
}
::ng-deep .cdk-drag-preview .action-button-container {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
}
::ng-deep .cdk-drag-preview .action-button-container .action-button {
  display: inline-flex !important;
  margin-right: 16px;
}

::ng-deep .cdk-drag-placeholder {
  background: #e0e0e0 !important;
  position: relative;
  height: 80px;
}
::ng-deep .cdk-drag-placeholder td {
  color: transparent !important;
  border: none !important;
  background: transparent !important;
  border-top: 2px dashed #bbb !important;
  border-bottom: 2px dashed #bbb !important;
}

.import-file-modal {
  max-width: 780px !important;
  width: 100%;
  margin: 5rem;
}
@media (max-width: 767px) {
  .import-file-modal {
    margin: 0;
  }
}

ion-datetime.md::part(calendar-day active),
ion-datetime.md::part(calendar-day active):focus {
  background-color: rgb(174, 15, 10);
  border-color: rgb(174, 15, 10);
  color: #fff;
}

ion-picker {
  --highlight-background: rgba(174, 15, 10, 1) !important;
}

ion-picker-column-option {
  --ion-color-base: #fff;
}

ion-datetime {
  --ion-background-color-step-300: rgba(174, 15, 10, 1) !important;
  --ion-text-color: #fff !important;
}

.datetime-action-buttons-container ion-button {
  background: rgb(174, 15, 10) !important;
  border-radius: 8px;
  color: #fff;
}

.modal-container {
  padding-top: 0;
}
.modal-container .btn-clear-div {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.modal-container .btn-clear-div .btn-custom {
  color: #AE0F0A;
  text-transform: none;
  font-family: Barlow;
  font-weight: 600;
  font-size: 12px;
  line-height: 100%;
  vertical-align: middle;
  line-height: 19.2px;
  text-decoration: underline;
  text-decoration-style: solid;
}
.modal-container .header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.modal-container .header p {
  font-size: 1.2rem;
  font-weight: bold;
  margin-right: 1.2rem;
  font-family: "Montserrat", sans-serif;
}
.modal-container .btn-area {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 30px;
  height: 0px;
}

.form-group {
  display: flex;
  align-items: baseline;
  margin-bottom: 1rem;
}
.form-group .mat-mdc-form-field {
  width: 90%;
}

.mat-checkbox {
  margin-bottom: 10px;
}

.btn-primary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(174, 15, 10);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  margin-top: 2.5rem;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 100%;
    height: 45px;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2) {
  background: white;
  color: rgb(174, 15, 10);
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  font-weight: bold;
  margin-top: 2.5rem;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2) {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2)[disabled] {
  background: rgb(189, 188, 188);
}

.form-group-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.form-group-row .mat-mdc-form-field {
  width: 45%;
}

.first-input {
  width: 100% !important;
}

.date-select {
  width: 100%;
  display: flex;
}
.date-select .mat-mdc-form-field {
  margin-bottom: -1rem;
  width: 70%;
}
.date-select .select-year {
  margin-bottom: -1rem;
  width: 30%;
}

.row-one .mat-mdc-form-field {
  width: 45%;
}

.fields {
  min-height: 30vh;
}
.fields .field .icon-remove {
  position: absolute;
  top: 20px;
  right: 0px;
  width: 20px;
  height: 20px;
}
.fields ::ng-deep .field .mat-mdc-text-field-wrapper {
  background-color: white;
  width: 270px;
}
.fields ion-row {
  display: flex;
  flex-direction: row;
  gap: 30px;
  padding-left: 30px;
}

@media (max-width: 900px) {
  .form-group-row {
    flex-direction: column;
  }
  .form-group-row .mat-mdc-form-field {
    width: 100%;
  }
  .form-group-row .date-select {
    width: 100%;
  }
  .fields {
    flex: 1;
  }
  .btn-area {
    width: 100% !important;
    flex-direction: column;
    height: 100%;
  }
  .btn-area .btn-primary {
    width: 100%;
    margin: auto !important;
    margin-bottom: 1rem !important;
  }
}
.title-modal {
  font-weight: 700;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/components/modals/modal-filters/modal-filters.component.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/typography.scss","webpack://./src/theme/spacing.scss","webpack://./src/_styles-shared.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;CAAA;ACEA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0DAAA;AFMF;AEFA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8DAAA;AFIF;AEEE;EACE,qBAAA;EACA,kBAAA;EACA,gBAJW;EAKX,kBAAA;EACA,sDAAA;AFAJ;AEIE;EACE,yBAAA;EACA,kBAAA;EACA,gBAbW;EAcX,kBAAA;EACA,0DAAA;AFFJ;AEZE;EACE,qBAAA;EACA,kBAAA;EACA,gBAJW;EAKX,kBAAA;EACA,sDAAA;AFcJ;AEVE;EACE,yBAAA;EACA,kBAAA;EACA,gBAbW;EAcX,kBAAA;EACA,0DAAA;AFYJ;AE1BE;EACE,qBAAA;EACA,kBAAA;EACA,gBAJW;EAKX,kBAAA;EACA,sDAAA;AF4BJ;AExBE;EACE,yBAAA;EACA,kBAAA;EACA,gBAbW;EAcX,kBAAA;EACA,0DAAA;AF0BJ;AErBA;EACE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mEAAA;EAEA,mBAAA;AFsBF;AEnBA;EACE,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,mCAAA;AFqBF;;AElBA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AFqBF;;AElBA;;;;;;EAME,qCAAA;EACA,gBAAA;AFqBF;;AElBA;EACE,eAAA;EACA,iBAAA;AFqBF;;AElBA;EACE,eAAA;EACA,iBAAA;AFqBF;;AElBA;EACE,eAAA;EACA,iBAAA;AFqBF;;AElBA;EACE,eAAA;EACA,iBAAA;AFqBF;;AElBA;EACE,eAAA;EACA,iBAAA;AFqBF;;AElBA;EACE,eAAA;EACA,iBAAA;AFqBF;;AElBA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;AFqBF;;AElBA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AFqBF;;AElBA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AFqBF;;ACvJA;;;;;CAAA;AEeE;EACE,YAAA;AHiJJ;;AG/IE;EACE,gBAAA;AHkJJ;;AGhJE;EACE,kBAAA;AHmJJ;;AGjJE;EACE,mBAAA;AHoJJ;;AGlJE;EACE,iBAAA;AHqJJ;;AGnJE;EACE,iBAAA;EACA,kBAAA;AHsJJ;;AGpJE;EACE,gBAAA;EACA,mBAAA;AHuJJ;;AGpJE;EACE,WAAA;AHuJJ;;AGrJE;EACE,eAAA;AHwJJ;;AGtJE;EACE,iBAAA;AHyJJ;;AGvJE;EACE,kBAAA;AH0JJ;;AGxJE;EACE,gBAAA;AH2JJ;;AGzJE;EACE,gBAAA;EACA,iBAAA;AH4JJ;;AG1JE;EACE,eAAA;EACA,kBAAA;AH6JJ;;AG1ME;EACE,YAAA;AH6MJ;;AG3ME;EACE,gBAAA;AH8MJ;;AG5ME;EACE,kBAAA;AH+MJ;;AG7ME;EACE,mBAAA;AHgNJ;;AG9ME;EACE,iBAAA;AHiNJ;;AG/ME;EACE,iBAAA;EACA,kBAAA;AHkNJ;;AGhNE;EACE,gBAAA;EACA,mBAAA;AHmNJ;;AGhNE;EACE,WAAA;AHmNJ;;AGjNE;EACE,eAAA;AHoNJ;;AGlNE;EACE,iBAAA;AHqNJ;;AGnNE;EACE,kBAAA;AHsNJ;;AGpNE;EACE,gBAAA;AHuNJ;;AGrNE;EACE,gBAAA;EACA,iBAAA;AHwNJ;;AGtNE;EACE,eAAA;EACA,kBAAA;AHyNJ;;AGtQE;EACE,aAAA;AHyQJ;;AGvQE;EACE,iBAAA;AH0QJ;;AGxQE;EACE,mBAAA;AH2QJ;;AGzQE;EACE,oBAAA;AH4QJ;;AG1QE;EACE,kBAAA;AH6QJ;;AG3QE;EACE,kBAAA;EACA,mBAAA;AH8QJ;;AG5QE;EACE,iBAAA;EACA,oBAAA;AH+QJ;;AG5QE;EACE,YAAA;AH+QJ;;AG7QE;EACE,gBAAA;AHgRJ;;AG9QE;EACE,kBAAA;AHiRJ;;AG/QE;EACE,mBAAA;AHkRJ;;AGhRE;EACE,iBAAA;AHmRJ;;AGjRE;EACE,iBAAA;EACA,kBAAA;AHoRJ;;AGlRE;EACE,gBAAA;EACA,mBAAA;AHqRJ;;AGlUE;EACE,aAAA;AHqUJ;;AGnUE;EACE,iBAAA;AHsUJ;;AGpUE;EACE,mBAAA;AHuUJ;;AGrUE;EACE,oBAAA;AHwUJ;;AGtUE;EACE,kBAAA;AHyUJ;;AGvUE;EACE,kBAAA;EACA,mBAAA;AH0UJ;;AGxUE;EACE,iBAAA;EACA,oBAAA;AH2UJ;;AGxUE;EACE,YAAA;AH2UJ;;AGzUE;EACE,gBAAA;AH4UJ;;AG1UE;EACE,kBAAA;AH6UJ;;AG3UE;EACE,mBAAA;AH8UJ;;AG5UE;EACE,iBAAA;AH+UJ;;AG7UE;EACE,iBAAA;EACA,kBAAA;AHgVJ;;AG9UE;EACE,gBAAA;EACA,mBAAA;AHiVJ;;AG9XE;EACE,aAAA;AHiYJ;;AG/XE;EACE,iBAAA;AHkYJ;;AGhYE;EACE,mBAAA;AHmYJ;;AGjYE;EACE,oBAAA;AHoYJ;;AGlYE;EACE,kBAAA;AHqYJ;;AGnYE;EACE,kBAAA;EACA,mBAAA;AHsYJ;;AGpYE;EACE,iBAAA;EACA,oBAAA;AHuYJ;;AGpYE;EACE,YAAA;AHuYJ;;AGrYE;EACE,gBAAA;AHwYJ;;AGtYE;EACE,kBAAA;AHyYJ;;AGvYE;EACE,mBAAA;AH0YJ;;AGxYE;EACE,iBAAA;AH2YJ;;AGzYE;EACE,iBAAA;EACA,kBAAA;AH4YJ;;AG1YE;EACE,gBAAA;EACA,mBAAA;AH6YJ;;AG1bE;EACE,aAAA;AH6bJ;;AG3bE;EACE,iBAAA;AH8bJ;;AG5bE;EACE,mBAAA;AH+bJ;;AG7bE;EACE,oBAAA;AHgcJ;;AG9bE;EACE,kBAAA;AHicJ;;AG/bE;EACE,kBAAA;EACA,mBAAA;AHkcJ;;AGhcE;EACE,iBAAA;EACA,oBAAA;AHmcJ;;AGhcE;EACE,YAAA;AHmcJ;;AGjcE;EACE,gBAAA;AHocJ;;AGlcE;EACE,kBAAA;AHqcJ;;AGncE;EACE,mBAAA;AHscJ;;AGpcE;EACE,iBAAA;AHucJ;;AGrcE;EACE,iBAAA;EACA,kBAAA;AHwcJ;;AGtcE;EACE,gBAAA;EACA,mBAAA;AHycJ;;AGtfE;EACE,aAAA;AHyfJ;;AGvfE;EACE,iBAAA;AH0fJ;;AGxfE;EACE,mBAAA;AH2fJ;;AGzfE;EACE,oBAAA;AH4fJ;;AG1fE;EACE,kBAAA;AH6fJ;;AG3fE;EACE,kBAAA;EACA,mBAAA;AH8fJ;;AG5fE;EACE,iBAAA;EACA,oBAAA;AH+fJ;;AG5fE;EACE,YAAA;AH+fJ;;AG7fE;EACE,gBAAA;AHggBJ;;AG9fE;EACE,kBAAA;AHigBJ;;AG/fE;EACE,mBAAA;AHkgBJ;;AGhgBE;EACE,iBAAA;AHmgBJ;;AGjgBE;EACE,iBAAA;EACA,kBAAA;AHogBJ;;AGlgBE;EACE,gBAAA;EACA,mBAAA;AHqgBJ;;AGljBE;EACE,aAAA;AHqjBJ;;AGnjBE;EACE,iBAAA;AHsjBJ;;AGpjBE;EACE,mBAAA;AHujBJ;;AGrjBE;EACE,oBAAA;AHwjBJ;;AGtjBE;EACE,kBAAA;AHyjBJ;;AGvjBE;EACE,kBAAA;EACA,mBAAA;AH0jBJ;;AGxjBE;EACE,iBAAA;EACA,oBAAA;AH2jBJ;;AGxjBE;EACE,YAAA;AH2jBJ;;AGzjBE;EACE,gBAAA;AH4jBJ;;AG1jBE;EACE,kBAAA;AH6jBJ;;AG3jBE;EACE,mBAAA;AH8jBJ;;AG5jBE;EACE,iBAAA;AH+jBJ;;AG7jBE;EACE,iBAAA;EACA,kBAAA;AHgkBJ;;AG9jBE;EACE,gBAAA;EACA,mBAAA;AHikBJ;;AG9mBE;EACE,aAAA;AHinBJ;;AG/mBE;EACE,iBAAA;AHknBJ;;AGhnBE;EACE,mBAAA;AHmnBJ;;AGjnBE;EACE,oBAAA;AHonBJ;;AGlnBE;EACE,kBAAA;AHqnBJ;;AGnnBE;EACE,kBAAA;EACA,mBAAA;AHsnBJ;;AGpnBE;EACE,iBAAA;EACA,oBAAA;AHunBJ;;AGpnBE;EACE,YAAA;AHunBJ;;AGrnBE;EACE,gBAAA;AHwnBJ;;AGtnBE;EACE,kBAAA;AHynBJ;;AGvnBE;EACE,mBAAA;AH0nBJ;;AGxnBE;EACE,iBAAA;AH2nBJ;;AGznBE;EACE,iBAAA;EACA,kBAAA;AH4nBJ;;AG1nBE;EACE,gBAAA;EACA,mBAAA;AH6nBJ;;AG1qBE;EACE,aAAA;AH6qBJ;;AG3qBE;EACE,iBAAA;AH8qBJ;;AG5qBE;EACE,mBAAA;AH+qBJ;;AG7qBE;EACE,oBAAA;AHgrBJ;;AG9qBE;EACE,kBAAA;AHirBJ;;AG/qBE;EACE,kBAAA;EACA,mBAAA;AHkrBJ;;AGhrBE;EACE,iBAAA;EACA,oBAAA;AHmrBJ;;AGhrBE;EACE,YAAA;AHmrBJ;;AGjrBE;EACE,gBAAA;AHorBJ;;AGlrBE;EACE,kBAAA;AHqrBJ;;AGnrBE;EACE,mBAAA;AHsrBJ;;AGprBE;EACE,iBAAA;AHurBJ;;AGrrBE;EACE,iBAAA;EACA,kBAAA;AHwrBJ;;AGtrBE;EACE,gBAAA;EACA,mBAAA;AHyrBJ;;AGtuBE;EACE,aAAA;AHyuBJ;;AGvuBE;EACE,iBAAA;AH0uBJ;;AGxuBE;EACE,mBAAA;AH2uBJ;;AGzuBE;EACE,oBAAA;AH4uBJ;;AG1uBE;EACE,kBAAA;AH6uBJ;;AG3uBE;EACE,kBAAA;EACA,mBAAA;AH8uBJ;;AG5uBE;EACE,iBAAA;EACA,oBAAA;AH+uBJ;;AG5uBE;EACE,YAAA;AH+uBJ;;AG7uBE;EACE,gBAAA;AHgvBJ;;AG9uBE;EACE,kBAAA;AHivBJ;;AG/uBE;EACE,mBAAA;AHkvBJ;;AGhvBE;EACE,iBAAA;AHmvBJ;;AGjvBE;EACE,iBAAA;EACA,kBAAA;AHovBJ;;AGlvBE;EACE,gBAAA;EACA,mBAAA;AHqvBJ;;AIxyBA;EACE;;;;;cAAA;EAMA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA,kEAAA;AJwyBF;;AIryBA;EACE,2CAAA;AJwyBF;;AIryBA;EACE,2CAAA;AJwyBF;;AIryBA;EACE,2CAAA;AJwyBF;;AIryBA;EACE,kCAAA;AJwyBF;;AIpyBE;EACE,aAAA;AJuyBJ;;AInyBA;EACE,cAAA;AJsyBF;;AInyBA;EACE,cAAA;EACA,eAAA;EACA,oBAAA;AJsyBF;;AInyBA;EACE,cAAA;EACA,eAAA;AJsyBF;;AInyBA;EACE,cAAA;EACA,eAAA;AJsyBF;;AInyBA;EACE,cAAA;EACA,eAAA;AJsyBF;;AInyBA;EACE,cAAA;EACA,eAAA;AJsyBF;;AInyBA;EACE,cAAA;EACA,eAAA;AJsyBF;;AInyBA;EACE,cAAA;EACA,eAAA;AJsyBF;;AInyBA;EACE,cAAA;EACA,eAAA;AJsyBF;;AInyBA;EACE,cAAA;EACA,eAAA;AJsyBF;;AInyBA;EACE,YAAA;AJsyBF;;AInyBA;EACE,gBAAA;AJsyBF;AIpyBE;EACE,aAAA;EACA,cAAA;EACA,gBAAA;AJsyBJ;;AIlyBA;EACE,aAAA;EACA,YAAA;EACA,iBAAA;AJqyBF;;AIlyBA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;AJqyBF;;AIlyBA;EACE,+BAAA;AJqyBF;AInyBE;EACE,qBAAA;EACA,aAAA;AJqyBJ;AIlyBE;EACE,qBAAA;AJoyBJ;;AIhyBA;EACE,aAAA;AJmyBF;;AIhyBA,8EAAA;AACA,2DAAA;AACA,wCAAA;AACA,uCAAA;AACA;EACE,wCAAA;AJmyBF;;AIhyBA,iDAAA;AACA;EACE,wCAAA;AJmyBF;;AIhyBA;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AJmyBF;AIjyBE;EACE,aAAA;AJmyBJ;;AI/xBA;EACE,6CAAA;EAEA,oCAAA;EACA,gCAAA;AJiyBF;AI/xBE;EACE,4BAAA;AJiyBJ;;AI7xBA;EACE,mBAAA;AJgyBF;;AI7xBA;EACE,gBAAA;EACA,mBAAA;AJgyBF;;AI7xBA,oBAAA;AACA;EACE,aAAA;AJgyBF;;AI7xBA;EACE,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,0BAAA;AJgyBF;AI9xBE;EApBF;IAqBI,WAAA;EJiyBF;AACF;;AI9xBA;EACE,oCAAA;EACA,yBAAA;AJiyBF;;AI9xBA;EACE,iCAAA;EACA,oCAAA;AJiyBF;;AI9xBA;EACE,kCAAA;EACA,2BAAA;AJiyBF;;AI9xBA;EACE,2BAAA;EACA,eAAA;AJiyBF;;AI9xBA;EACE,kCAAA;EACA,kCAAA;EACA,YAAA;EACA,kCAAA;EACA,6BAAA;AJiyBF;;AI9xBA;EACE,0BAAA;EACA,4BAAA;EACA,2BAAA;AJiyBF;AI/xBE;EALF;IAMI,0BAAA;IACA,6BAAA;EJkyBF;AACF;;AI/xBA;EACE,0BAAA;AJkyBF;AIhyBE;EAHF;IAII,qBAAA;EJmyBF;AACF;;AI/xBE;EADF;IAEI,wBAAA;EJmyBF;AACF;;AIhyBA;EACE,kBAAA;AJmyBF;AIjyBE;EAHF;IAII,2BAAA;EJoyBF;AACF;;AIjyBA;EAGE,6BAAA;EACA,kBAAA;AJkyBF;;AI/xBA;EAGE,kBAAA;EACA,UAAA;AJgyBF;;AI7xBA;;EAEE,+CAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AJgyBF;;AI7xBA;EACE,0BAAA;EACA,4BAAA;AJgyBF;AI9xBE;EACE,gCAAA;AJgyBJ;;AI5xBA,2BAAA;AAEA;EACE,SAAA;AJ8xBF;;AI3xBA;EACE,WAAA;EACA,2BAAA;AJ8xBF;AI5xBE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;AJ8xBJ;AI3xBE;EACE,uBAAA;AJ6xBJ;AI1xBE;EACE,kBAAA;AJ4xBJ;;AIxxBA;EACE,WAAA;EACA,2BAAA;AJ2xBF;;AIxxBA;EACE,WAAA;EACA,gBAAA;AJ2xBF;AIzxBE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,yBAAA;AJ2xBJ;AIxxBE;EACE,uBAAA;AJ0xBJ;AIvxBE;EACE,kBAAA;AJyxBJ;;AIrxBA;EACE,WAAA;EACA,gBAAA;AJwxBF;AItxBE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;AJwxBJ;AIrxBE;EACE,uBAAA;AJuxBJ;AIpxBE;EACE,kBAAA;AJsxBJ;;AIlxBA;EACE,WAAA;EACA,gBAAA;AJqxBF;AInxBE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AJqxBJ;AIlxBE;EACE,uBAAA;AJoxBJ;AIjxBE;EACE,kBAAA;AJmxBJ;;AI/wBA;EACE,aAAA;AJkxBF;;AI/wBA;EACE,2BAAA;AJkxBF;AI/wBI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AJixBN;AI9wBI;EACE,iBAAA;EACA,eAAA;AJgxBN;AI7wBI;EACE,mBAAA;AJ+wBN;AI5wBI;EACE,2CAAA;AJ8wBN;;AIzwBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AJ4wBF;;AIzwBA;EACE,oBAAA;EACA,mBAAA;AJ4wBF;AI1wBE;EACE,YAAA;EACA,WAAA;AJ4wBJ;;AIxwBA;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;AJ2wBF;AIzwBE;EACE,YAAA;EACA,WAAA;AJ2wBJ;;AIvwBA;EACE,4BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AJ0wBF;AIxwBE;EAXF;IAYI,gBAAA;IACA,0BAAA;IACA,WAAA;IACA,YAAA;EJ2wBF;AACF;AIzwBE;EACE,8BAAA;AJ2wBJ;AIxwBE;EACE,WAAA;AJ0wBJ;;AItwBA;EACE,iBAAA;EACA,uBAAA;EACA,kCAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AJywBF;AIvwBE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EJ0wBF;AACF;AIxwBE;EACE,yBAAA;EACA,gCAAA;AJ0wBJ;AIvwBE;EACE,WAAA;AJywBJ;AItwBE;EACE,YAAA;AJwwBJ;;AIpwBA;EACE,8BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AJuwBF;AIrwBE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EJwwBF;AACF;AItwBE;EACE,WAAA;AJwwBJ;;AIpwBA;EACE,aAAA;EACA,mBAAA;AJuwBF;AIrwBE;EACE,WAAA;AJuwBJ;AIpwBE;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;AJswBJ;AIpwBI;EACE,wBAAA;AJswBN;AInwBI;EACE,uBAAA;AJqwBN;AIlwBI;EACE,uBAAA;AJowBN;AIjwBI;EACE,uBAAA;AJmwBN;AIhwBI;EACE,uBAAA;AJkwBN;AI/vBI;EACE,sBAAA;AJiwBN;AI7vBE;EACE,uBAAA;AJ+vBJ;AI5vBE;EACE,uBAAA;AJ8vBJ;;AI1vBA;EACE,0BAAA;AJ6vBF;;AI1vBA;EACE,6CAAA;AJ6vBF;;AI1vBA;EACE,8BAAA;AJ6vBF;;AI1vBA;EACE,gBAAA;AJ6vBF;;AI1vBA;EACE,qDAAA;EACA,mEAAA;EACA,yEAAA;EACA,2EAAA;EACA,yEAAA;EACA;;;;;cAAA;EAMA;;;;;cAAA;EAMA;;;;;cAAA;AJkwBF;;AI1vBA;;CAAA;AAGA;EACE,iBAAA;AJ6vBF;;AI1vBA;EACE,kBAAA;AJ6vBF;;AI1vBA;EACE,gBAAA;AJ6vBF;;AI1vBA;EACE,kBAAA;AJ6vBF;;AI1vBA;EACE,gBAAA;AJ6vBF;;AI1vBA;EACE,gBAAA;AJ6vBF;;AI1vBA;EACE,UAAA;AJ6vBF;;AI1vBA;;EAEE,WAAA;EACA,cAAA;AJ6vBF;;AI1vBA;EACE,iDAAA;EACA,8DAAA;EACA,uDAAA;AJ6vBF;;AI1vBA;;EAEE,8BAAA;EACA,iDAAA;EACA,+BAAA;EACA,yCAAA;EACA,4DAAA;EACA,0DAAA;EACA,0DAAA;AJ6vBF;;AI1vBA;EACE,iCAAA;AJ6vBF;;AI1vBA;EACE,mCAAA;AJ6vBF;;AI1vBA;EACE,iCAAA;AJ6vBF;;AI1vBA;EACE,iCAAA;AJ6vBF;;AI1vBA;EACE;IACE,uBAAA;IACA,wBAAA;EJ6vBF;EI1vBA;IACE,kBAAA;IACA,qBAAA;EJ4vBF;AACF;AIzvBA;EACE;IACE,iBAAA;EJ2vBF;AACF;AIxvBA;EACE;IACE,uBAAA;IACA,wBAAA;EJ0vBF;AACF;AIvvBA;EACE;IACE,iBAAA;IACA,8CAAA;EJyvBF;AACF;AItvBA;EACE,iBAAA;AJwvBF;;AIrvBA;EACE,iBAAA;AJwvBF;;AIrvBA;EACE,cAAA;AJwvBF;AItvBE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AJwvBJ;AItvBI;EACE,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qCAAA;AJwvBN;;AInvBA;EACE,aAAA;EACA,cAAA;AJsvBF;AIpvBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AJsvBJ;AIpvBI;EACE,gBAAA;EACA,eAAA;AJsvBN;AInvBI;EACE,eAAA;EACA,iBAAA;AJqvBN;;AIhvBA;EACE,cAAA;AJmvBF;AIjvBE;EAHF;IAII,aAAA;IACA,cAAA;EJovBF;AACF;AIlvBE;EACE,gBAAA;EACA,cAAA;AJovBJ;AIjvBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AJmvBJ;AIjvBI;EACE,gBAAA;EACA,eAAA;AJmvBN;AIhvBI;EACE,eAAA;EACA,iBAAA;AJkvBN;;AI7uBA;EACE,uBAAA;AJgvBF;;AI7uBA;EACE,aAAA;EACA,eAAA;AJgvBF;AI9uBE;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,WAAA;AJgvBJ;;AI5uBA;EACE,kBAAA;AJ+uBF;;AI5uBA;EACE,gBAAA;AJ+uBF;;AI5uBA;EACE,gBAAA;EACA,kBAAA;AJ+uBF;;AI5uBA;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;AJ+uBF;;AI5uBA;EACE,gBAAA;AJ+uBF;;AI5uBA;EACE,iBAAA;AJ+uBF;;AI5uBA;;CAAA;AAGA;EACE,kCAAA;EACA,cAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AJ+uBF;;AI5uBA;EACE,qBAAA;AJ+uBF;;AI5uBA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AJ+uBF;AI7uBE;EACE,WAAA;AJ+uBJ;AI5uBE;EACE;IACE,aAAA;EJ8uBJ;AACF;;AI1uBA;EACE,qBAAA;AJ6uBF;;AI1uBA;;CAAA;AAMI;EACE,cAAA;AJ0uBN;AIvuBI;EACE,gBAAA;EACA,0BAAA;EACA,iCAAA;AJyuBN;AItuBI;EACE,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,oCAAA;AJwuBN;AIruBI;EACE,yBAAA;AJuuBN;AIpuBI;EACE,gBAAA;EACA,uBAAA;AJsuBN;AInuBI;EACE,gBAAA;EACA,yBAAA;AJquBN;;AIhuBA;EACE,iDAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;AJmuBF;AIjuBE;EANF;IAOI,oIAAA;EJouBF;AACF;;AI/tBE;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,sBAAA;AJkuBJ;;AI7tBE;EACE,mCAAA;AJguBJ;AI7tBE;EACE,wBAAA;EACA,kBAAA;AJ+tBJ;;AI1tBE;EACE,kCAAA;AJ6tBJ;AI1tBE;EACE,uBAAA;EACA,kBAAA;AJ4tBJ;;AIvtBE;EACE,mCAAA;AJ0tBJ;AIvtBE;EACE,wBAAA;EACA,kBAAA;AJytBJ;;AIrtBA;EACE,kBAAA;EACA,kBAAA;AJwtBF;AIttBE;EACE,cAAA;AJwtBJ;AIrtBE;EACE,sCAAA;EACA,+CAAA;AJutBJ;;AIntBA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AJstBF;;AIltBE;EACE,qBAAA;AJqtBJ;;AIjtBA;EACE,iDAAA;EACA,mDAAA;AJotBF;;AIjtBA;EACE,yBAAA;AJotBF;;AIjtBA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;AJotBF;;AIjtBA;EACE,aAAA;EACA,iBAAA;AJotBF;;AIjtBA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AJotBF;AIltBE;EACE,kBAAA;AJotBJ;;AIhtBA;EACE,+BAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;AJmtBF;AIjtBE;EACE,sBAAA;AJmtBJ;;AI/sBA;EACE,qBAAA;EACA,sCAAA;AJktBF;AIhtBE;EACE,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uDAAA;AJktBJ;AI9sBI;EACE,2BAAA;AJgtBN;;AI3sBA;EACE,qCAAA;AJ8sBF;;AI3sBA;EACE,kCAAA;EACA,gBAAA;EACA,eAAA;AJ8sBF;;AI3sBA;EACE,oCAAA;EACA,gBAAA;EACA,eAAA;AJ8sBF;;AI3sBA;;EAEE,2EAAA;EACA,yEAAA;EACA,qEAAA;EACA,uEAAA;EACA;;;;;cAAA;EAMA;;;;;cAAA;EAMA;;;;;cAAA;EAMA;;;;;cAAA;AJmtBF;;AI3sBA;EACE,+CAAA;AJ8sBF;;AI3sBA;EACE,kCAAA;AJ8sBF;;AI3sBA;EACE,6CAAA;AJ8sBF;;AI1sBA;EACE,cAAA;EACA,oCAAA;EACA,kBAAA;EACA,qHACE;EAIF,WAAA;EACA,mBAAA;AJysBF;AIvsBE;EACE,aAAA;EACA,6BAAA;AJysBJ;;AIrsBA;EACE,YAAA;EACA,mBAAA;AJwsBF;;AIrsBA;EACE,sDAAA;AJwsBF;;AIrsBA;EACE,sDAAA;AJwsBF;;AIrsBA;EACE,YAAA;AJwsBF;;AIrsBA;EACE,aAAA;AJwsBF;;AIrsBA;EACE,cAAA;EACA,WAAA;AJwsBF;;AIrsBA;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4FACE;AJusBJ;AIpsBE;EACE,8BAAA;EACA,sBAAA;EACA,aAAA;AJssBJ;AInsBE;EACE,wBAAA;EACA,8BAAA;EACA,4BAAA;AJqsBJ;AInsBI;EACE,+BAAA;EACA,kBAAA;AJqsBN;;AIhsBA;EACE,8BAAA;EACA,kBAAA;EAUA,YAAA;AJ0rBF;AIlsBE;EACE,6BAAA;EACA,uBAAA;EACA,kCAAA;EACA,sCAAA;EACA,yCAAA;AJosBJ;;AI9rBA;EACE,2BAAA;EACA,WAAA;EACA,YAAA;AJisBF;AI/rBE;EALF;IAMI,SAAA;EJksBF;AACF;;AI/rBA;;EAEE,kCAAA;EACA,8BAAA;EACA,WAAA;AJksBF;;AI/rBA;EACE,uDAAA;AJksBF;;AI/rBA;EACE,sBAAA;AJksBF;;AI/rBA;EACE,gEAAA;EACA,iCAAA;AJksBF;;AI/rBA;EACE,uCAAA;EACA,kBAAA;EACA,WAAA;AJksBF;;AAn8DA;EACE,cAAA;AAs8DF;AAp8DE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAs8DJ;AAp8DI;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;EACA,4BAAA;AAs8DN;AAl8DE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAo8DJ;AAl8DI;EACE,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qCAAA;AAo8DN;AAh8DE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAk8DJ;;AA97DA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;AAi8DF;AA/7DE;EACE,UAAA;AAi8DJ;;AA77DA;EACE,mBAAA;AAg8DF;;AA77DA;EACE,4BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAg8DF;AA97DE;EAZF;IAaI,gBAAA;IACA,0BAAA;IACA,WAAA;IACA,YAAA;EAi8DF;AACF;AA/7DE;EACE,8BAAA;AAi8DJ;;AA77DA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAg8DF;AA97DE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EAi8DF;AACF;AA/7DE;EACE,8BAAA;AAi8DJ;;AA77DA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAg8DF;AA97DE;EACE,UAAA;AAg8DJ;;AA57DA;EACE,sBAAA;AA+7DF;;AA57DA;EACE,WAAA;EACA,aAAA;AA+7DF;AA77DE;EACE,oBAAA;EACA,UAAA;AA+7DJ;AA57DE;EACE,oBAAA;EACA,UAAA;AA87DJ;;AAz7DE;EACE,UAAA;AA47DJ;;AAx7DA;EACE,gBAAA;AA27DF;AAx7DI;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AA07DN;AAt7DE;EACE,uBAAA;EACA,YAAA;AAw7DJ;AAr7DE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAu7DJ;;AAn7DA;EACE;IACE,sBAAA;EAs7DF;EAp7DE;IACE,WAAA;EAs7DJ;EAn7DE;IACE,WAAA;EAq7DJ;EAj7DA;IACE,OAAA;EAm7DF;EAh7DA;IACE,sBAAA;IACA,sBAAA;IACA,YAAA;EAk7DF;EAh7DE;IACE,WAAA;IACA,uBAAA;IACA,8BAAA;EAk7DJ;AACF;AA96DA;EACA,gBAAA;EACA,eAAA;AAg7DA","sourcesContent":["@import \"src/styles-shared\";\n\n.modal-container {\n  padding-top: 0;\n\n  .btn-clear-div {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 20px;\n\n    .btn-custom {\n      color: #AE0F0A;\n      text-transform: none;\n      font-family: Barlow;\n      font-weight: 600;\n      font-size: 12px;\n      line-height: 100%;\n      vertical-align: middle;\n      line-height: 19.2px;\n      text-decoration: underline;\n      text-decoration-style: solid;\n    }\n  }\n\n  .header {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n\n    p {\n      font-size: 1.2rem;\n      font-weight: bold;\n      margin-right: 1.2rem;\n      font-family: \"Montserrat\", sans-serif;\n    }\n  }\n\n  .btn-area {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: row;\n    gap: 30px;\n    height: 0px;\n  }\n}\n\n.form-group {\n  display: flex;\n  align-items: baseline;\n  margin-bottom: 1rem;\n\n  .mat-mdc-form-field {\n    width: 90%;\n  }\n}\n\n.mat-checkbox {\n  margin-bottom: 10px;\n}\n\n.btn-primary.mat-mdc-unelevated-button.mat-unthemed {\n  background: map-get($primary-color, 500);\n  color: white;\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: none;\n  font-weight: bold;\n  margin-top: 2.5rem;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    margin-right: 0 !important;\n    width: 100%;\n    height: 45px;\n  }\n\n  &[disabled] {\n    background: map-get($medium-color, 700);\n  }\n}\n\n.btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2) {\n  background: white;\n  color: map-get($primary-color, 500);\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  font-weight: bold;\n  margin-top: 2.5rem;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    width: 100%;\n    height: 45px;\n  }\n\n  &[disabled] {\n    background: map-get($medium-color, 700);\n  }\n}\n\n.form-group-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .mat-mdc-form-field {\n    width: 45%;\n  }\n}\n\n.first-input {\n  width: 100% !important;\n}\n\n.date-select {\n  width: 100%;\n  display: flex;\n\n  .mat-mdc-form-field {\n    margin-bottom: -1rem;\n    width: 70%;\n  }\n\n  .select-year {\n    margin-bottom: -1rem;\n    width: 30%;\n  }\n}\n\n.row-one {\n  .mat-mdc-form-field {\n    width: 45%;\n  }\n}\n\n.fields {\n  min-height: 30vh;\n\n  .field {\n    .icon-remove {\n      position: absolute;\n      top: 20px;\n      right: 0px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  ::ng-deep .field .mat-mdc-text-field-wrapper {\n    background-color: white;\n    width: 270px;\n  }\n\n  ion-row {\n    display: flex;\n    flex-direction: row;\n    gap: 30px;\n    padding-left: 30px;\n  }\n}\n\n@media (max-width: 900px) {\n  .form-group-row {\n    flex-direction: column;\n\n    .mat-mdc-form-field {\n      width: 100%;\n    }\n\n    .date-select {\n      width: 100%;\n    }\n  }\n\n  .fields {\n    flex: 1;\n  }\n\n  .btn-area {\n    width: 100% !important;\n    flex-direction: column;\n    height: 100%;\n\n    .btn-primary {\n      width: 100%;\n      margin: auto !important;\n      margin-bottom: 1rem !important;\n    }\n  }\n}\n\n.title-modal{\nfont-weight: 700;\nfont-size: 16px;\n}","/* \n\tColors values \n\t300 = tint\n\t500 = default\n\t700 = shade\n*/\n$primary-color: (\n  500: rgba(174, 15, 10, 1),\n  300: rgba(227, 6, 19, 1),\n  700: rgba(228, 173, 181, 1),\n  contrast: (\n    500: white,\n    300: white,\n    700: black,\n  ),\n);\n\n$warning-color: (\n  500: rgba(255, 196, 9, 1),\n  300: rgba(255, 202, 34, 1),\n  700: rgba(224, 172, 8, 1),\n  contrast: (\n    500: black,\n    300: black,\n    700: black,\n  ),\n);\n\n$danger-color: (\n  500: rgba(235, 68, 90, 1),\n  300: rgba(237, 87, 107, 1),\n  700: rgba(207, 60, 79, 1),\n  contrast: (\n    500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$success-color: (\n  500: rgba(45, 211, 111, 1),\n  300: rgba(66, 215, 125, 1),\n  700: rgba(40, 186, 98, 1),\n  contrast: (\n    500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$dark-color: (\n  500: rgba(34, 36, 40, 1),\n  300: rgba(60, 60, 59, 1),\n  700: rgba(87, 87, 86, 1),\n  contrast: (\n    500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$medium-color: (\n  500: rgba(112, 111, 111, 1),\n  300: rgba(135, 135, 135, 1),\n  700: rgba(189, 188, 188, 1),\n  contrast: (\n    500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$light-color: (\n  500: rgba(227, 227, 227, 1),\n  300: rgba(245, 246, 249, 1),\n  700: rgba(189, 188, 188, 1),\n  contrast: (\n    500: black,\n    300: black,\n    700: black,\n  ),\n);\n","@import \"variables\";\n\n@font-face {\n  font-family: \"Barlow\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(\"../assets/fonts/barlow/barlow-v13-latin-regular.woff2\")\n    format(\"woff2\");\n}\n\n@font-face {\n  font-display: swap;\n  font-family: \"Montserrat\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"../assets/fonts/montserrat/montserrat-v31-latin-regular.woff2\")\n    format(\"woff2\");\n}\n\n// Sem estes pesos o navegador não sintetiza o negrito e todo 500/600/700 sai regular.\n@each $peso in 500, 600, 700 {\n  @font-face {\n    font-family: \"Barlow\";\n    font-style: normal;\n    font-weight: $peso;\n    font-display: swap;\n    src: url(\"../assets/fonts/barlow/barlow-v13-latin-#{$peso}.woff2\")\n      format(\"woff2\");\n  }\n\n  @font-face {\n    font-family: \"Montserrat\";\n    font-style: normal;\n    font-weight: $peso;\n    font-display: swap;\n    src: url(\"../assets/fonts/montserrat/montserrat-v31-latin-#{$peso}.woff2\")\n      format(\"woff2\");\n  }\n}\n\n@font-face {\n  font-family: \"Material Icons\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"../assets/fonts/material/material-icons-v145-latin-regular.woff2\")\n    format(\"woff2\");\n  font-display: block;\n}\n\n.material-icons {\n  font-family: \"Material Icons\";\n  font-weight: normal;\n  font-style: normal;\n  font-size: 24px;\n  line-height: 1;\n  letter-spacing: normal;\n  text-transform: none;\n  display: inline-block;\n  white-space: nowrap;\n  word-wrap: normal;\n  direction: ltr;\n  -webkit-font-smoothing: antialiased;\n}\n\nbody {\n  font-family: \"Barlow\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 19px;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 600;\n}\n\nh1 {\n  font-size: 64px;\n  line-height: 78px;\n}\n\nh2 {\n  font-size: 56px;\n  line-height: 68px;\n}\n\nh3 {\n  font-size: 48px;\n  line-height: 58px;\n}\n\nh4 {\n  font-size: 40px;\n  line-height: 48px;\n}\n\nh5 {\n  font-size: 32px;\n  line-height: 39px;\n}\n\nh6 {\n  font-size: 24px;\n  line-height: 29px;\n}\n\na {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 19px;\n  color: map-get($primary-color, 500);\n  cursor: pointer;\n  text-decoration: underline;\n}\n\ncaption {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14px;\n}\n\nth {\n  font-weight: 700;\n  cursor: pointer;\n  text-wrap: nowrap;\n}\n","$spacing-sizes: (\n  0: 0px,\n  1: 8px,\n  2: 16px,\n  3: 24px,\n  4: 32px,\n  5: 40px,\n  6: 48px,\n  7: 56px,\n  8: 64px,\n  9: 72px,\n  10: 80px,\n);\n\n@each $key, $size in $spacing-sizes {\n  .p-#{$key} {\n    padding: #{$size};\n  }\n  .pt-#{$key} {\n    padding-top: #{$size};\n  }\n  .pr-#{$key} {\n    padding-right: #{$size};\n  }\n  .pb-#{$key} {\n    padding-bottom: #{$size};\n  }\n  .pl-#{$key} {\n    padding-left: #{$size};\n  }\n  .px-#{$key} {\n    padding-left: #{$size};\n    padding-right: #{$size};\n  }\n  .py-#{$key} {\n    padding-top: #{$size};\n    padding-bottom: #{$size};\n  }\n\n  .m-#{$key} {\n    margin: #{$size};\n  }\n  .mt-#{$key} {\n    margin-top: #{$size};\n  }\n  .mr-#{$key} {\n    margin-right: #{$size};\n  }\n  .mb-#{$key} {\n    margin-bottom: #{$size};\n  }\n  .ml-#{$key} {\n    margin-left: #{$size};\n  }\n  .mx-#{$key} {\n    margin-left: #{$size};\n    margin-right: #{$size};\n  }\n  .my-#{$key} {\n    margin-top: #{$size};\n    margin-bottom: #{$size};\n  }\n}\n","// Corpo compartilhado do stylesheet global, sem `@use \"@angular/material\"`.\n// Os .scss de componente importam este arquivo, não o styles.scss: alcançar\n// o @use do Material a partir de um @import de componente faz o build do Sass\n// falhar de forma intermitente (module loop / mixin indefinido) no CI.\n\n@import \"theme/typography.scss\";\n@import \"theme/variables.scss\";\n@import \"theme/spacing\";\n\nhtml {\n  --mdc-outlined-text-field-focus-outline-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n  --mdc-outlined-text-field-focus-label-text-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-option-selected-state-label-text-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-datepicker-toggle-active-state-icon-color: rgba(\n    174,\n    15,\n    10,\n    1\n  ) !important;\n\n  --mat-paginator-enabled-icon-color: rgba(34, 36, 40, 1) !important;\n}\n\n::ng-deep .mdc-notched-outline__leading {\n  border-color: rgba(239, 239, 239, 1) !important;\n}\n\n::ng-deep .mdc-notched-outline__notch {\n  border-color: rgba(239, 239, 239, 1) !important;\n}\n\n::ng-deep .mdc-notched-outline__trailing {\n  border-color: rgba(239, 239, 239, 1) !important;\n}\n\n.mat-drawer-content {\n  background-color: white !important;\n}\n\n.no-subscript {\n  .mat-mdc-form-field-subscript-wrapper {\n    display: none;\n  }\n}\n\n.modal-lg {\n  --width: 670px;\n}\n\n.modal-foto-crop {\n  --width: 520px;\n  --height: 640px;\n  --border-radius: 8px;\n}\n\n.modal-lg-user {\n  --width: 600px;\n  --height: 495px;\n}\n\n.modal-lg-equipamentos {\n  --width: 470px;\n  --height: 550px;\n}\n\n.modal-lg-consorcio {\n  --width: 600px;\n  --height: 515px;\n}\n\n.modal-lg-add-consorcio {\n  --width: 790px;\n  --height: 590px;\n}\n\n.modal-lg-endereço {\n  --width: 600px;\n  --height: 475px;\n}\n\n.modal-lg-comunicacao-qco {\n  --width: 470px;\n  --height: 280px;\n}\n\n.modal-lg-gerar-qco {\n  --width: 440px;\n  --height: 235px;\n}\n\n.modal-motivo-recusa {\n  --width: 470px;\n  --height: 280px;\n}\n\n.popover-content {\n  width: 23rem;\n}\n\nion-popover.notifications-popover {\n  --offset-y: 20px;\n\n  &::part(content) {\n    padding: 15px;\n    overflow: auto;\n    max-height: 80vh;\n  }\n}\n\nion-popover::part(content) {\n  padding: 20px;\n  height: auto;\n  overflow: visible;\n}\n\nion-popover.workflow-status::part(content) {\n  padding: 8px;\n  height: auto;\n  overflow: visible;\n}\n\nion-popover {\n  --height: var(--popover-height);\n\n  &.workflow-status {\n    --backdrop-opacity: 0;\n    --width: auto;\n  }\n\n  &.datetime-popover {\n    --backdrop-opacity: 0;\n  }\n}\n\nion-accordion ion-icon.ion-accordion-toggle-icon {\n  display: none;\n}\n\n/* You can add global styles to this file, and also import other style files */\n/* Angular 15 adds grey background on mat form components */\n/* below removes that background color */\n/* Manipulate initial background color*/\n.mdc-text-field--filled:not(.mdc-text-field--disabled) {\n  background-color: transparent !important;\n}\n\n/*Manipulate background color on hover and focus*/\n.mat-mdc-form-field-focus-overlay {\n  background-color: transparent !important;\n}\n\n.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {\n  width: 0px;\n  padding-left: 6px;\n  padding-right: 6px;\n\n  span {\n    display: none;\n  }\n}\n\n.mat-mdc-table {\n  --mat-table-header-headline-line-height: 56px;\n\n  border-collapse: separate !important;\n  border-spacing: 0 4px !important;\n\n  thead {\n    border-spacing: 0 !important;\n  }\n}\n\n.mat-mdc-row {\n  margin-bottom: 10px;\n}\n\n.mat-mdc-cell {\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n\n/* Pagination menu */\n.g-bubble-container {\n  display: flex;\n}\n\n.g-bubble {\n  border: 1px solid rgba(239, 239, 239, 1);\n  margin: 0 10px;\n  border-radius: 4px;\n  min-width: 34px;\n  max-width: 40px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: map-get($dark-color, 500) !important;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: 0.3s;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0.5px;\n  text-align: center;\n  margin-right: 0 !important;\n\n  @media (max-width: 425px) {\n    width: 30px;\n  }\n}\n\n.g-bubble:hover {\n  background-color: map-get($light-color, 700);\n  color: map-get($light-color, 300);\n}\n\n.g-bubble__active {\n  background-color: map-get($primary-color, 300);\n  color: map-get($light-color, 500) !important;\n}\n\nmat-paginator {\n  background: transparent !important;\n  margin-top: 48px !important;\n}\n\n.mat-mdc-paginator-container {\n  justify-content: flex-start;\n  flex-wrap: wrap;\n}\n\n.mat-mdc-paginator-range-actions {\n  align-items: flex-start !important;\n  overflow-wrap: anywhere !important;\n  flex-grow: 1;\n  justify-content: center !important;\n  position: relative !important;\n}\n\n.bubble-paginator-dots {\n  font-size: 16px !important;\n  margin-right: 2px !important;\n  margin-left: 2px !important;\n\n  @media (max-width: 425px) {\n    font-size: 12px !important;\n    margin-right: -5px !important;\n  }\n}\n\n.mat-mdc-paginator-page-size {\n  margin-right: 0 !important;\n\n  @media (max-width: 320px) {\n    width: 33% !important;\n  }\n}\n\n.mat-mdc-paginator-page-size-label {\n  @media (max-width: 496px) {\n    display: none !important;\n  }\n}\n\n.mat-mdc-paginator-range-label {\n  align-self: center;\n\n  @media (max-width: 768px) {\n    margin-left: 0px !important;\n  }\n}\n\n.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size)\n  .mat-mdc-paginator-range-actions\n  .mat-mdc-paginator-range-label {\n  position: absolute !important;\n  left: 0 !important;\n}\n\n.mat-mdc-paginator-container:not(:has(.mat-mdc-paginator-page-size))\n  .mat-mdc-paginator-range-actions\n  .mat-mdc-paginator-range-label {\n  position: absolute;\n  left: 24px;\n}\n\n.mat-mdc-paginator-navigation-next,\n.mat-mdc-paginator-navigation-previous {\n  border: 1px solid rgba(239, 239, 239, 1) !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: map-get($dark-color, 500) !important;\n  padding: 0 !important;\n  border-radius: 4px !important;\n  width: 28px !important;\n  height: 34px !important;\n  margin-left: 8px !important;\n}\n\n.mat-mdc-paginator-page-size-select {\n  max-width: 60px !important;\n  margin-right: 8px !important;\n\n  .mat-mdc-text-field-wrapper {\n    padding: 0 8px 0 16px !important;\n  }\n}\n\n/* End of pagination menu */\n\nbody {\n  margin: 0;\n}\n\n.snackbar {\n  width: 50vw;\n  margin: 10px 0px !important;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snackbar-custom {\n  width: 50vw;\n  margin-top: 75px !important;\n}\n\n.snacbar-warning {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid #e0ac08;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snacbar-sucess {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid green;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snacbar-error {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid red;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.flex {\n  display: flex;\n}\n\n.mat-mdc-menu-panel {\n  overflow: hidden !important;\n\n  .mat-mdc-menu-content {\n    .menu-header {\n      font-size: 12px;\n      padding: 1rem;\n      padding-bottom: 0.25rem;\n    }\n\n    .mat-mdc-menu-item {\n      margin-left: 1rem;\n      padding-left: 0;\n    }\n\n    .mat-mdc-menu-item:first-of-type {\n      margin-top: 0.75rem;\n    }\n\n    .mat-mdc-menu-item:not(:last-child) {\n      border-bottom: 1px solid map-get($light-color, 700);\n    }\n  }\n}\n\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 30000;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sort-icon-container {\n  display: inline-flex;\n  align-items: center;\n\n  mat-icon {\n    height: 1rem;\n    width: 1rem;\n  }\n}\n\n.drag-icon-container {\n  display: inline-flex;\n  align-items: center;\n  margin-right: 12px;\n\n  mat-icon {\n    height: 1rem;\n    width: 14px;\n  }\n}\n\n.btn-primary.mat-mdc-unelevated-button.mat-unthemed {\n  background: map-get($primary-color, 500);\n  color: white;\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0.25rem;\n  border: none;\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    margin-right: 0 !important;\n    width: 100%;\n    height: 45px;\n  }\n\n  &[disabled] {\n    background: rgba(239, 239, 239, 1);\n  }\n\n  &.btn-small {\n    width: 7rem;\n  }\n}\n\n.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {\n  background: white;\n  color: map-get($primary-color, 500);\n  border: 1px solid map-get($primary-color, 500);\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0.25rem;\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    width: 100%;\n    height: 45px;\n  }\n\n  &[disabled] {\n    color: map-get($primary-color, 700);\n    border-color: map-get($primary-color, 700);\n  }\n\n  &.btn-small {\n    width: 7rem;\n  }\n\n  &.no-border {\n    border: none;\n  }\n}\n\n.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {\n  background: map-get($medium-color, 700);\n  color: white;\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0.25rem;\n  border: none;\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    width: 100%;\n    height: 45px;\n  }\n\n  &.btn-small {\n    width: 7rem;\n  }\n}\n\n.status-container {\n  display: flex;\n  align-items: center;\n\n  .mat-icon {\n    width: 1rem;\n  }\n\n  .status-icon {\n    font-size: 8px;\n    align-content: center;\n    text-align: center;\n    margin-right: 8px;\n\n    &.verde {\n      color: rgba(41, 204, 106, 1);\n    }\n\n    &.amarelo {\n      color: rgba(255, 196, 9, 1);\n    }\n\n    &.azul {\n      color: rgba(0, 153, 255, 1);\n    }\n\n    &.lilas {\n      color: rgba(82, 96, 255, 1);\n    }\n\n    &.roxo {\n      color: rgba(82, 96, 255, 1);\n    }\n\n    &.vermelho {\n      color: rgba(227, 6, 19, 1);\n    }\n  }\n\n  .active {\n    color: map-get($success-color, 700);\n  }\n\n  .inactive {\n    color: map-get($danger-color, 500);\n  }\n}\n\n.text-capitalize {\n  text-transform: capitalize;\n}\n\n::ng-deep .mat-calendar-body-selected {\n  background-color: map-get($primary-color, 500) !important;\n}\n\n::ng-deep .mat-calendar-body-cell-content {\n  border-radius: 0rem !important;\n}\n\n::ng-deep .mat-calendar-body-selected.mat-calendar-body-today {\n  box-shadow: none;\n}\n\n.mat-checkbox.custom-checkbox {\n  --background-checked: rgba(174, 15, 10, 1) !important;\n  --mdc-checkbox-selected-icon-color: rgba(174, 15, 10, 1) !important;\n  --mdc-checkbox-selected-hover-icon-color: rgba(174, 15, 10, 1) !important;\n  --mdc-checkbox-selected-pressed-icon-color: rgba(174, 15, 10, 1) !important;\n  --mdc-checkbox-selected-focus-icon-color: rgba(174, 15, 10, 1) !important;\n  --mdc-checkbox-selected-focus-state-layer-color: rgba(\n    174,\n    15,\n    10,\n    1\n  ) !important;\n  --mdc-checkbox-selected-hover-state-layer-color: rgba(\n    174,\n    15,\n    10,\n    1\n  ) !important;\n  --mdc-checkbox-selected-pressed-state-layer-color: rgba(\n    174,\n    15,\n    10,\n    1\n  ) !important;\n}\n\n/* \n  IONIC components\n*/\n.margin-left {\n  margin-left: 1rem;\n}\n\n.margin-right {\n  margin-right: 1rem;\n}\n\n.margin-top {\n  margin-top: 1rem;\n}\n\n.margin-top-md {\n  margin-top: 0.5rem;\n}\n\n.margin-top-xl {\n  margin-top: 2rem;\n}\n\n.margin-bottom {\n  margin-top: 1rem;\n}\n\n.no-padding {\n  padding: 0;\n}\n\nion-input,\nmat-form-field {\n  width: 100%;\n  display: block;\n}\n\nion-checkbox {\n  --border-color: rgba(218, 218, 218, 1) !important;\n  --checkbox-background-checked: rgba(174, 15, 10, 1) !important;\n  --border-color-checked: rgba(174, 15, 10, 1) !important;\n}\n\nion-textarea,\nion-input {\n  --background: white !important;\n  --border-color: rgba(239, 239, 239, 1) !important;\n  --border-radius: 5px !important;\n  --highlight-color: rgba(135, 135, 135, 1);\n  --highlight-color-focused: rgba(135, 135, 135, 1) !important;\n  --highlight-color-valid: rgba(135, 135, 135, 1) !important;\n  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;\n}\n\nion-input label .label-text {\n  color: rgba(87, 87, 86, 1) !important;\n}\n\nion-input.valid-input label .label-text {\n  color: rgba(45, 211, 111, 1) !important;\n}\n\nion-input.invalid-input label .label-text {\n  color: rgba(227, 6, 19, 1) !important;\n}\n\nion-textarea label .label-text {\n  color: rgba(87, 87, 86, 1) !important;\n}\n\n@media (min-width: 1000px) {\n  .filter-panel {\n    width: 650px !important;\n    height: 450px !important;\n  }\n\n  .historic-panel {\n    min-width: 49.5rem;\n    min-height: 35.625rem;\n  }\n}\n\n@media (max-width: 900px) {\n  .filter-panel {\n    min-height: 30rem;\n  }\n}\n\n@media (max-width: 767px) {\n  .filter-panel {\n    width: 480px !important;\n    height: 650px !important;\n  }\n}\n\n@media (max-width: 600px) {\n  .mat-mdc-form-field-label {\n    font-size: 0.8rem;\n    /* Tamanho de fonte para dispositivos móveis */\n  }\n}\n\nion-modal.modal-xsm {\n  --max-height: 45%;\n}\n\nion-modal.modal-sm {\n  --max-height: 65%;\n}\n\nion-modal.modal-h-auto {\n  --height: auto;\n\n  .header {\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n\n    ion-item {\n      font-size: 1.2rem;\n      font-weight: bold;\n      margin-right: 1.2rem;\n      font-family: \"Montserrat\", sans-serif;\n    }\n  }\n}\n\nion-modal.modal-w-auto {\n  --width: auto;\n  overflow: auto;\n\n  .header {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 8px;\n\n    ion-item {\n      font-weight: 700;\n      font-size: 16px;\n    }\n\n    ion-icon {\n      font-size: 16px;\n      margin-right: 8px;\n    }\n  }\n}\n\nion-modal.modal-hw-auto {\n  overflow: auto;\n\n  @media (min-width: 768px) {\n    --width: auto;\n    --height: auto;\n  }\n\n  .ion-delegate-host.ion-page {\n    max-height: 100%;\n    overflow: auto;\n  }\n\n  .header {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 8px;\n\n    ion-item {\n      font-weight: 700;\n      font-size: 16px;\n    }\n\n    ion-icon {\n      font-size: 16px;\n      margin-right: 8px;\n    }\n  }\n}\n\nion-alert.custom-alert {\n  --backdrop-opacity: 0.7;\n}\n\nion-list.filtered-list {\n  display: flex;\n  flex-wrap: wrap;\n\n  span {\n    padding: 0.75rem 0;\n    margin: 0 0.75rem;\n    border-bottom: 1px solid map-get($light-color, 700);\n    width: 100%;\n  }\n}\n\nion-item.no-padding-start {\n  --padding-start: 0;\n}\n\nion-item.no-padding-end {\n  --padding-end: 0;\n}\n\nion-item.no-padding {\n  --padding-end: 0;\n  --padding-start: 0;\n}\n\nion-item.no-padding-full {\n  --padding-end: 0;\n  --padding-start: 0;\n  --inner-padding-end: 0;\n  --inner-padding-start: 0;\n}\n\nion-input.no-padding-end {\n  --padding-end: 0;\n}\n\nion-item {\n  overflow: visible;\n}\n\n/* \n  Mais filtros\n*/\nion-button.more-filters-btn {\n  --background: rgba(174, 15, 10, 1);\n  --color: white;\n  --border-radius: 10px;\n  width: 114px;\n  height: 36px;\n  max-width: 15rem;\n  text-transform: capitalize;\n  font-size: 0.9rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n}\n\nion-item.fast-filters {\n  padding: 0.25rem 0rem;\n}\n\n.more-filters-btn-row {\n  justify-content: center;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n\n  button {\n    margin: 5px;\n  }\n\n  @media (max-width: 767px) {\n    button {\n      margin: 5px 0;\n    }\n  }\n}\n\nion-col {\n  padding: 0 !important;\n}\n\n/* \n  IONIC alert\n*/\n\n.custom-alert {\n  .alert-wrapper {\n    .alert-head {\n      padding-top: 0;\n    }\n\n    .alert-title {\n      font-weight: 700;\n      font-size: 1rem !important;\n      color: map-get($dark-color, 500) !important;\n    }\n\n    .alert-message {\n      font-weight: 400;\n      font-size: 1rem !important;\n      line-height: 24px;\n      color: map-get($medium-color, 500) !important;\n    }\n\n    .alert-button-group {\n      justify-content: flex-end;\n    }\n\n    button.alert-button.alert-button-confirm {\n      font-weight: 600;\n      color: map-get($primary-color, 500);\n    }\n\n    button.alert-button.alert-button-cancel {\n      font-weight: 600;\n      color: rgba(112, 111, 111, 1);\n    }\n  }\n}\n\nion-toast.snackbar-toast {\n  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);\n  --width: fit-content;\n  --border-radius: 0.75rem;\n  --white-space: pre-line;\n\n  @media (min-width: 768px) {\n    transform: translateY(calc(20px + var(--ion-safe-area-top, 0px)))\n      translateX(calc(-12px + var(--ion-safe-area-top, 0px))) !important;\n  }\n}\n\nion-toast.snackbar-toast {\n  &::part(container) {\n    background: #fff;\n    color: rgba(34, 36, 40, 1);\n    width: fit-content;\n    border-radius: 0.75rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-success {\n  &::part(container) {\n    border: 1px solid rgba(45, 211, 111, 1);\n  }\n\n  &::part(icon) {\n    color: rgba(45, 211, 111, 1);\n    font-size: 1.25rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-error {\n  &::part(container) {\n    border: 1px solid rgba(235, 68, 90, 1);\n  }\n\n  &::part(icon) {\n    color: rgba(235, 68, 90, 1);\n    font-size: 1.25rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-warning {\n  &::part(container) {\n    border: 1px solid rgba(255, 165, 10, 1);\n  }\n\n  &::part(icon) {\n    color: rgba(255, 165, 10, 1);\n    font-size: 1.25rem;\n  }\n}\n\nion-toast.snackbar-toast {\n  --box-shadow: none;\n  --background: none;\n\n  &.toast-right {\n    --start: right;\n  }\n\n  &::part(container) {\n    transform: translateY(72px) !important;\n    box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);\n  }\n}\n\nion-icon.search-icon-absolute {\n  position: absolute;\n  left: 16px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  z-index: 3;\n}\n\nion-input.search-input {\n  label.input-wrapper {\n    --padding-start: 55px;\n  }\n}\n\nion-toggle {\n  --handle-background-checked: rgba(174, 15, 10, 1);\n  --track-background-checked: rgba(174, 15, 10, 0.38);\n}\n\n.cdk-overlay-container {\n  z-index: 30000 !important;\n}\n\n.btn-transparent {\n  background: none;\n  border: none;\n  padding: 0;\n  display: inline-block;\n}\n\n.column-flex {\n  display: flex;\n  flex-flow: column;\n}\n\n.master-icon {\n  background-color: map-get($warning-color, 300);\n  color: map-get($dark-color, 500);\n  border-radius: 10px;\n  align-self: flex-start;\n  font-size: 10px;\n  padding: 0px 9px;\n  margin: 6px 0;\n  line-height: 17px;\n  font-weight: 600;\n\n  &.center-horizontal {\n    place-self: center;\n  }\n}\n\n.truncate-text-vertical {\n  display: -webkit-box !important;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  &.break-word {\n    word-break: break-word;\n  }\n}\n\n.custom-tooltip {\n  white-space: pre-line;\n  transform: translateY(16px) !important;\n\n  .mdc-tooltip__surface {\n    padding: 8px 24px;\n    min-width: max-content;\n    border: 1px solid #706f6f;\n    --mdc-plain-tooltip-container-color: #383637 !important;\n  }\n\n  &.strong {\n    .mdc-tooltip__surface {\n      font-weight: 700 !important;\n    }\n  }\n}\n\n.cal-header {\n  text-transform: capitalize !important;\n}\n\n.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {\n  color: map-get($primary-color, 500) !important;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.mdc-tab__text-label {\n  color: map-get($medium-color, 500) !important;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.mat-mdc-tab-group,\n.mat-mdc-tab-nav-bar {\n  --mdc-tab-indicator-active-indicator-color: rgba(174, 15, 10, 1) !important;\n  --mat-tab-header-active-label-text-color: rgba(174, 15, 10, 1) !important;\n  --mat-tab-header-active-ripple-color: rgba(174, 15, 10, 1) !important;\n  --mat-tab-header-inactive-ripple-color: rgba(174, 15, 10, 1) !important;\n  --mat-tab-header-active-focus-label-text-color: rgba(\n    174,\n    15,\n    10,\n    1\n  ) !important;\n  --mat-tab-header-active-hover-label-text-color: rgba(\n    174,\n    15,\n    10,\n    1\n  ) !important;\n  --mat-tab-header-active-focus-indicator-color: rgba(\n    174,\n    15,\n    10,\n    1\n  ) !important;\n  --mat-tab-header-active-hover-indicator-color: rgba(\n    174,\n    15,\n    10,\n    1\n  ) !important;\n}\n\n.mat-mdc-tab-header {\n  background-color: rgba(244, 244, 244, 1) !important;\n}\n\n.mdc-tab-indicator--active {\n  background-color: white !important;\n}\n\n.mat-badge-content {\n  background-color: map-get($primary-color, 500) !important;\n}\n\n// table-drag\n.cdk-drag-preview {\n  display: table;\n  background: rgba(41, 204, 106, 0.08);\n  border-radius: 4px;\n  box-shadow:\n    0 5px 5px -3px rgba(0, 0, 0, 0.2),\n    0 8px 10px 1px rgba(0, 0, 0, 0.14),\n    0 3px 14px 2px rgba(0, 0, 0, 0.12);\n\n  width: 100%;\n  table-layout: fixed;\n\n  td {\n    padding: 16px;\n    border-bottom: 1px solid #eee;\n  }\n}\n\n.cdk-drag-placeholder {\n  opacity: 0.5;\n  background: #f0f0f0;\n}\n\n.cdk-drag-animating {\n  transition: transform 100ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.cdk-drop-list-dragging .mat-row:not(.cdk-drag-placeholder) {\n  transition: transform 100ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.drag-enabled {\n  cursor: move;\n}\n\n.drag-handle {\n  display: none;\n}\n\n.drag-enabled .drag-handle {\n  display: block;\n  color: #999;\n}\n\n::ng-deep .cdk-drag-preview {\n  display: table !important;\n  table-layout: fixed;\n  width: 100%;\n  background: white;\n  border-radius: 4px;\n  box-shadow:\n    0 5px 5px -3px rgba(41, 204, 106, 0.08),\n    0 8px 10px 1px rgba(41, 204, 106, 0.08);\n\n  td {\n    display: table-cell !important;\n    vertical-align: middle;\n    padding: 16px;\n  }\n\n  .action-button-container {\n    display: flex !important;\n    flex-direction: row !important;\n    flex-wrap: nowrap !important;\n\n    .action-button {\n      display: inline-flex !important;\n      margin-right: 16px;\n    }\n  }\n}\n\n::ng-deep .cdk-drag-placeholder {\n  background: #e0e0e0 !important;\n  position: relative;\n\n  td {\n    color: transparent !important;\n    border: none !important;\n    background: transparent !important;\n    border-top: 2px dashed #bbb !important;\n    border-bottom: 2px dashed #bbb !important;\n  }\n\n  height: 80px;\n}\n\n.import-file-modal {\n  max-width: 780px !important;\n  width: 100%;\n  margin: 5rem;\n\n  @media (max-width: 767px) {\n    margin: 0;\n  }\n}\n\nion-datetime.md::part(calendar-day active),\nion-datetime.md::part(calendar-day active):focus {\n  background-color: map-get($primary-color, 500);\n  border-color: map-get($primary-color, 500);\n  color: #fff;\n}\n\nion-picker {\n  --highlight-background: rgba(174, 15, 10, 1) !important;\n}\n\nion-picker-column-option {\n  --ion-color-base: #fff;\n}\n\nion-datetime {\n  --ion-background-color-step-300: rgba(174, 15, 10, 1) !important;\n  --ion-text-color: #fff !important;\n}\n\n.datetime-action-buttons-container ion-button {\n  background: rgba(174, 15, 10, 1) !important;\n  border-radius: 8px;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
